<template>
  <div>
     <el-button v-if="['3'].includes(orderDetail.status) && orderDetail.type !== 19"
                style="margin-top: 6px"
                type="danger"
                size="mini"
                @click="onFinish">强制完成
     </el-button>
     <el-button v-if="canResetProcess(orderDetail)"
                style="margin-top: 6px"
                type="danger"
                size="mini"
                @click="resetProcess">重置进行中
     </el-button>
     <el-button v-if="(orderDetail.status === '-1') || orderDetail.status === '-2'"
                style="margin-top: 6px"
                type="danger"
                size="mini"
                @click="resetFinish">重置待审核
     </el-button>
  </div>
</template>

<script>
import OrderResetProcessForm from '@views/order/components/OrderResetProcessForm.vue'

export default {
  components: {},
  mixins: [],
  props: {
    orderDetail: Object,
    components: Object,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    async onFinish () {
      let orderid = this.orderDetail.orderid
      if (orderid) {
        await this.$confirm('你确定要强制完成任务吗？')
        await request.alert('orderFinishEnforce', {orderid: orderid})
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        })
        this.$store.dispatch('setOrderDetail', {id: orderid})
      }
    },
    async resetFinish (scopeRow) {
      let orderid = this.orderDetail.orderid
      if (orderid) {
        await this.$confirm('你确定要重新置为待审核状态吗？')
        await request.alert('orderReset2Finish', {orderid: orderid})
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        })
        this.$store.dispatch('setOrderDetail', {id: orderid})
      }
    },
    async resetProcess () {
      let orderid = this.orderDetail.orderid
      if (orderid) {
        const h = this.$createElement
        const content = h(OrderResetProcessForm)
        let hours
        await this.$confirm(content, '重置进行中', {
          closeOnClickModal: false,
          beforeClose (action, instance, done) {
            if (action === 'confirm' && content.componentInstance) {
              hours = content.componentInstance.getValue()
            }
            done()
          },
        })
        await request.alert('orderReset2Process', {orderid: orderid, hours: hours})
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success',
        })
        this.$store.dispatch('setOrderDetail', {id: orderid})
      }
    },
    canResetProcess (orderDetail) {
      return orderDetail.status * 1 === -1 && filter.hasPermission(40011)
    }
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderResetFinishButton.vue